module.exports = __webpack_public_path__ + "static/img/nigong6.9197b992.jpg";